import AudioBroadCast from 'views/BroadCast/BroadCast.container';

export default AudioBroadCast;
